import React from "react";
import { useLocation } from "react-router-dom";
import { Eye, ShieldCheck } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { TIER_LABEL } from "../lib/permissions";

const TIERS = ["family", "player", "trainer", "agent", "lite"];

// Admin-only floating switch: see the player profile / dashboard exactly as each tier does.
// Desktop: pill bar at the bottom-right (clear of the sticky tab bar). Mobile: compact select.
export function ViewAsToggle() {
  const { canPreview, previewTier, setPreviewTier } = useAuth();
  const { pathname } = useLocation();
  if (!canPreview || !(pathname.startsWith("/player/") || pathname.startsWith("/home/") || pathname.startsWith("/my-players"))) return null;
  const btn = (active) => `flex items-center gap-1.5 px-2.5 py-2 text-[10px] uppercase tracking-[0.2em] font-bold transition-colors ${active ? "bg-[var(--org-accent)] text-[#121212]" : "text-[#a0a0a0] hover:text-white"}`;
  return (
    <div className="fixed bottom-16 right-4 sm:right-5 z-40 flex items-center border border-white/15 bg-[#0f0f0f]/95 backdrop-blur shadow-2xl" data-testid="view-as-toggle">
      <span className="px-3 text-[9px] uppercase tracking-[0.3em] text-[#757575]"><Eye className="w-3.5 h-3.5 inline sm:hidden" /><span className="hidden sm:inline">Viewing as</span></span>
      <select value={previewTier || ""} onChange={e => setPreviewTier(e.target.value || null)} className="sm:hidden bg-transparent text-[10px] uppercase tracking-[0.2em] font-bold text-[var(--org-accent)] pr-3 py-2 focus:outline-none" data-testid="view-as-select" aria-label="Viewing as">
        <option value="">Admin</option>
        {TIERS.map(t => <option key={t} value={t}>{TIER_LABEL[t]}</option>)}
      </select>
      <div className="hidden sm:flex items-center">
        <button type="button" onClick={() => setPreviewTier(null)} aria-pressed={!previewTier} data-testid="view-as-admin" className={btn(!previewTier)}>
          <ShieldCheck className="w-3.5 h-3.5" /> Admin
        </button>
        {TIERS.map(t => (
          <button key={t} type="button" onClick={() => setPreviewTier(t)} aria-pressed={previewTier === t} data-testid={`view-as-${t}`} className={`${btn(previewTier === t)} whitespace-nowrap`}>
            {TIER_LABEL[t]}
          </button>
        ))}
      </div>
    </div>
  );
}
